import React from 'react';
import PropTypes from 'prop-types';
import { OneExperimentsProvider } from '@americanexpress/one-experiments';

/*
 * LegacyOneXPWrapper is not the same as the new OneXpWrapper.
 * the key difference is the way the OneExperimentsProvider is fetches experiments data.
 * it makes a find call everytime the user navigates to a new page.
 * you want to use this component if your experiments use the
 * url regex to determine if the user is in an experiment.
 * disableRouteChangeFetch will prevent the find call from happening altogether
 * from what we have observed, it wont call it from initial load either.
 * this is important in those cases where we dont want the call to happen.
 */

const LegacyOneXPWrapper = ({ children, route }) => (
  <OneExperimentsProvider disableRouteChangeFetch={route.disableRouteChangeFetch}>
    {children}
  </OneExperimentsProvider>
);
LegacyOneXPWrapper.propTypes = {
  children: PropTypes.node,
  route: PropTypes.shape({
    disableRouteChangeFetch: PropTypes.bool,
  }).isRequired,
};

LegacyOneXPWrapper.defaultProps = {
  children: null,
};

export default LegacyOneXPWrapper;
